import React from "react";
import axios from "axios";

function DownloadPage() {
    const handleSupremeDownload = () => {
        window.location.href = "https://drive.google.com/uc?export=download&id=1yn0Jb9nxG-E4_zb3X7f0YWssh9VdpgaM";
    };

    const handleNikeDownload = () => {
        window.location.href = "https://drive.google.com/uc?export=download&id=1CfShYcu12tIw44BySoFIpDYG9dWM0a8F";
    };

    return (
        <div style={styles.container}>
            <h3 style={styles.label}>Windows:</h3>
            <button onClick={handleSupremeDownload} style={styles.button}>
                Download Supreme Bot
            </button>
            <button onClick={handleNikeDownload} style={{ ...styles.button, marginTop: "12px" }}>
                Download Nike Bot
            </button>
        </div>
    );
}

// ✅ Inline Styles for Centering & Button Styling
const styles = {
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
        color: "#FFFFFF",
    },
    label: {
        fontSize: "24px",
        fontWeight: "bold",
        marginBottom: "10px",
    },
    button: {
        backgroundColor: "#FF0000",
        color: "#FFFFFF",
        fontSize: "18px",
        padding: "12px 24px",
        border: "none",
        borderRadius: "5px",
        cursor: "pointer",
        transition: "background-color 0.3s",
    },
};

export default DownloadPage;
